<ng-container *ngIf="widgetConfig$ | async as config">
  <ng-container *ngIf="config.enabled">
    <a
      id="linkToRewards"
      [title]="accountFirstConnectedHeaderTooltipString"
      [routerLink]="config.link"
      routerLinkActive
      #rla="routerLinkActive"
      class="fa-gift fa-solid"
    >
      <span *ngIf="config.points" id="cart_counter" class="first-points">{{ config.points | number }}</span>
    </a>
  </ng-container>
</ng-container>
